import { computed } from 'vue';
import { i18n } from '@/locales';
import { isRequired } from './index';
const createDeliveryChargeAreaControlFormRules = (formRuleLc) => ({
    currentAreaName: computed({
        get() {
            return [
                (v) => isRequired(v) || i18n.t(`${formRuleLc}value_require`),
            ];
        },
        set() { },
    }),
});
export default createDeliveryChargeAreaControlFormRules;
